/* eslint-disable */
import React from "react";
import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import CtaForm from "../../ui/CTAForm";
import { CtaFormBlock } from "../../lib/storyblok/types/blocks/CtaFormBlock";
import { imageSizes, isValidImageData } from "../../lib/utils/imageUtils";
import StoryblokImage from "../StoryblokImage";
import { useContentStyle } from "../../hooks/useStyle";

const CTAForm: StoryblokBlockComponent<CtaFormBlock> = ({
  text,
  title,
  copy,
  image,
  formUrl,
  spacing,
  style,
  divider,
}) => {
  const contentStyle = useContentStyle(style);
  const isInverted = style === "" || style === undefined ? false : contentStyle;

  // Sometimes form urls contain go.Tobii.com (uppercase T in the url) due to translations. This little tweak addresses this.
  const normalizedFormUrl =
    formUrl && formUrl.includes("go.Tobii.com")
      ? formUrl.replace("go.Tobii.com", "go.tobii.com")
      : formUrl;
  const sanitizedFormUrl = normalizedFormUrl ? normalizedFormUrl.trim() : ""; // Ensure formUrl has no leading/trailing spaces

  return (
    <CtaForm
      title={title}
      text={text}
      copy={copy}
      image={
        image &&
        isValidImageData(image) && (
          <StoryblokImage
            resize={{ width: 960 }}
            sizes={imageSizes("100vw", {
              desktop: "960px",
            })}
            image={image}
            alt={title || image.alt || ""}
          />
        )
      }
      formUrl={sanitizedFormUrl}
      spacing={spacing}
      style={style}
      divider={divider}
      inverted={isInverted}
    />
  );
};

export default CTAForm;
